import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-purple-50 border-b border-purple-200 pa-6 pb-0 flex flex-col"},[_c('div',{staticClass:"w-min flex items-center back-btn cursor-pointer",on:{"click":_vm.backBtnClicked}},[_c(VIcon,{staticClass:"icon"},[_vm._v("mdi-arrow-left")]),_c('span',{staticClass:"text text-gray-600"},[_vm._v("Back")])],1),_c('h1',{staticClass:"font text-3xl font-semibold my-2"},[_vm._v("Air Road Jobs")])])
}
var staticRenderFns = []

export { render, staticRenderFns }